// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubscriptionBanner__Alert {
  max-height: 8rem;
  justify-content: space-between;
}
.SubscriptionBanner__Alert--Hidden {
  max-height: 0;
  opacity: 0;
  transition: all 0.5s ease-in-out, max-height 0.25s ease-in-out 0.4s;
  margin-bottom: 0;
  padding: 0;
}
.SubscriptionBanner__Label {
  text-align: center;
}
.SubscriptionBanner__Link {
  font-weight: bold;
  color: white;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./apps/app/src/app/views/home-list/subscription-banner/home-list-subscription-banner.component.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;EACA,8BAAA;AAAJ;AAEI;EACE,aAAA;EACA,UAAA;EACA,mEACE;EAEF,gBAAA;EACA,UAAA;AAFN;AAME;EACE,kBAAA;AAJJ;AAOE;EACE,iBAAA;EACA,YAAA;EACA,0BAAA;AALJ","sourcesContent":[".SubscriptionBanner {\n  &__Alert {\n    max-height: 8rem;\n    justify-content: space-between;\n\n    &--Hidden {\n      max-height: 0;\n      opacity: 0;\n      transition:\n        all 0.5s ease-in-out,\n        max-height 0.25s ease-in-out 0.4s;\n      margin-bottom: 0;\n      padding: 0;\n    }\n  }\n\n  &__Label {\n    text-align: center;\n  }\n\n  &__Link {\n    font-weight: bold;\n    color: white;\n    text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
